module.exports = $uibModalProvider => {
  $uibModalProvider.options.backdrop = 'static';
  $uibModalProvider.options.keyboard = false;
};
